import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Header from './Header';
import { AuthProvider } from './contexts/AuthContext';
import { MessagesProvider } from './contexts/MessagesContext';
import ErrorBoundary from './components/ErrorBoundary';
import AuthRoute from './components/AuthRoute';
import { ROUTES } from './constants';

// Lazy load pages for better performance
const Login = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const CreateLawsuitPublic = lazy(() => import('./pages/CreateLawsuitPublic'));
const Payment = lazy(() => import('./pages/Payment'));

// Loading component
const LoadingFallback = () => (
  <div className="loading-state" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <div className="spinner"></div>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <AuthProvider>
          <MessagesProvider>
            <Router>
              <div className="App">
                <Header />
                
                <main className="main">
                  <ErrorBoundary>
                    <Suspense fallback={<LoadingFallback />}>
                      <Routes>
                        {/* Strony tylko dla niezalogowanych */}
                        <Route path={ROUTES.HOME} element={
                          <AuthRoute requireAuth={false} to={ROUTES.DASHBOARD}>
                            <Login />
                          </AuthRoute>
                        } />
                        <Route path={ROUTES.REGISTER} element={
                          <AuthRoute requireAuth={false} to={ROUTES.DASHBOARD}>
                            <Register />
                          </AuthRoute>
                        } />
                        <Route path={ROUTES.FORGOT_PASSWORD} element={
                          <AuthRoute requireAuth={false} to={ROUTES.DASHBOARD}>
                            <ForgotPassword />
                          </AuthRoute>
                        } />
                        
                        {/* Formularz pozwu - dostępny dla wszystkich (publiczna wersja) */}
                        <Route path={ROUTES.CREATE_LAWSUIT} element={<CreateLawsuitPublic />} />
                        
                        {/* Płatność - dostępna bez logowania */}
                        <Route path={`${ROUTES.PAYMENT}/:uuid`} element={<Payment />} />
                        
                        {/* Strony chronione - tylko dla zalogowanych */}
                        <Route path={`${ROUTES.DASHBOARD}/*`} element={
                          <AuthRoute>
                            <Dashboard />
                          </AuthRoute>
                        } />
                      </Routes>
                    </Suspense>
                  </ErrorBoundary>
                </main>
              </div>
            </Router>
          </MessagesProvider>
        </AuthProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;

